import BigNumber from 'bignumber.js';
import _ from 'lodash';
import { trim } from 'rambdax';
import moment from 'moment';

export function isEqual(a, b) {
  const localA = new BigNumber(a);
  return localA.isEqualTo(b);
}

export function paramType(a) {
  if (typeof a === 'string') {
    // eslint-disable-next-line no-param-reassign
    a = a.replace(/\,/g, '');
  }
  if (!a || isNaN(a) || a === '' || (typeof a === 'string' && a.indexOf('e') > -1)) {
    // eslint-disable-next-line no-param-reassign
    a = 0;
  }
  return a;
}

/**
 * 加
 * @param a
 * @param b
 * @returns
 */
export const numberAdd = (a, b) => {
  const bn1 = new BigNumber(paramType(a));
  const bn2 = new BigNumber(paramType(b));
  const c = bn1.plus(bn2);

  return c.toFixed();
};

export const numberAdd2 = (a, b) => {
  const bn1 = new BigNumber(paramType(a));
  const bn2 = new BigNumber(paramType(b));
  const c = bn1.plus(bn2);

  return c;
};

/**
 * 减
 * @param a
 * @param b
 * @returns
 */
export const numberMinus = (a, b) => {
  const bn1 = new BigNumber(paramType(a));
  const bn2 = new BigNumber(paramType(b));
  const c = bn1.minus(bn2);

  return c.toFixed();
};

/**
 * 乘
 * @param a
 * @param b
 * @returns
 */
export const numberMutiply = (a, b) => {
  const bn1 = new BigNumber(paramType(a));
  const bn2 = new BigNumber(paramType(b));
  const c = bn1.multipliedBy(bn2);

  return c.toFixed();
};

export const numberMutiply2 = (a, b) => {
  const bn1 = new BigNumber(paramType(a));
  const bn2 = new BigNumber(paramType(b));
  const c = bn1.multipliedBy(bn2);

  return c;
};

/**
 * 除
 * @param a
 * @param b
 * @returns
 */
export const numberDivide = (a, b) => {
  const bn1 = new BigNumber(paramType(a));
  const bn2 = new BigNumber(paramType(b));
  const c = bn1.dividedBy(bn2);

  return c.toFixed();
};

export const formatNumberCutZero = (a, decimalPlace?) => {
  const value = numberMutiply(a, 1) as any;
  if (isNaN(value)) {
    return '';
  }
  const num = new BigNumber(value).toFormat(decimalPlace || 8);
  return removeDecimalZero(num);
};

export const formatNumberCutZeroNoFormat = (a, decimalPlace?) => {
  const value = numberMutiply(a, 1) as any;
  if (isNaN(value)) {
    return '';
  }
  const num = new BigNumber(value).toFixed(decimalPlace || 8);
  return removeDecimalZero(num);
};

export const fixedNumberCutZero = (a, decimalPlace?) => {
  if (a === '') return '';
  const value = numberMutiply(a, 1) as any;
  if (isNaN(value)) {
    return '0';
  }
  const num = new BigNumber(value).toFixed(decimalPlace || 8);
  return removeDecimalZero(num);
};

// 如果将位置1和位置2换成 ==，那么当金额为 0.00 时，该函数输出为0，不会保留小数
export const removeDecimalZero = (num) => {
  let newstr = num;
  let leng = num.length - num.indexOf('.') - 1;
  if (num.indexOf('.') > -1) {
    for (let i = leng; i > 0; i--) {
      if (newstr.lastIndexOf('0') > -1 && newstr.substr(newstr.length - 1, 1) === '0') {
        let k = newstr.lastIndexOf('0');
        // 位置2
        if (newstr.charAt(k - 1) === '.') {
          return newstr.substring(0, k - 1);
        } else {
          newstr = newstr.substring(0, k);
        }
      } else {
        return newstr;
      }
    }
  }
  return num;
};

export const comparedTo = (a, b) => {
  let bn1 = new BigNumber(paramType(a));
  let bn2 = new BigNumber(paramType(b));
  return bn1.comparedTo(bn2);
};

export const fixedDecimalPlaces = (a: BigNumber.Value, decimalPlaces: number) => {
  return new BigNumber(a).toFixed(decimalPlaces);
};

export const fixed4DecimalPlaces = (a: BigNumber.Value) => {
  return fixedDecimalPlaces(a, 4);
};

export const fixed2DecimalPlaces = (a: BigNumber.Value) => {
  return fixedDecimalPlaces(a, 2);
};

export const fixed8DecimalPlaces = (a: BigNumber.Value) => {
  return fixedDecimalPlaces(a, 8);
};

export const legitInputNumber = (val, decimalLength) => {
  const splitVal = val.toString().split('.');
  const oneDigit =
    splitVal.length > 1 ? `${splitVal[0]}.${splitVal[1]?.slice(0, decimalLength)}` : splitVal[0];

  const bNumberInstance = new BigNumber(oneDigit);
  const stringBNumber = bNumberInstance.toString();
  if (stringBNumber === 'NaN') {
    return 0;
  } else {
    return bNumberInstance.toFixed(decimalLength);
  }
};

export const getDecimalPlaces = (val) => {
  const splitVal = val.toString().split('.');

  if (splitVal.length >= 2) {
    return splitVal[1].length;
  } else {
    return 0;
  }
};

export const formatNumber = (a, decimalPlace = 4) => {
  let value: number | string = numberMutiply(a, 1);
  if (value.toString() === 'NaN') {
    value = 0;
  }
  return new BigNumber(value).toFormat(decimalPlace);
};

export const numberSum = (arr: any[], dp = 4) => {
  if (arr.length === 0) return 0;
  return BigNumber.sum(...arr.map((item) => new BigNumber(paramType(item)))).toFixed(dp);
};

export function isNullOrEmpty(value) {
  return value === undefined || value == null || (typeof value === 'string' && trim(value) === '');
}

export function isZeroLike(value) {
  if (isNullOrEmpty(value)) {
    return true;
  }

  const n = new BigNumber(value);

  if (n.isNaN()) {
    return true;
  }

  if (n.isEqualTo(0)) {
    return true;
  }
}

export function numberToUpper(money, cnInteger = '整', cnIntLast = '元') {
  let cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'); //汉字的数字
  let cnIntRadice = new Array('', '拾', '佰', '仟'); //基本单位
  let cnIntUnits = new Array('', '万', '亿', '兆'); //对应整数部分扩展单位
  let cnDecUnits = new Array('角', '分', '毫', '厘'); //对应小数部分单位
  let maxNum = 999999999999999.9999; //最大处理的数字
  let IntegerNum; //金额整数部分
  let DecimalNum; //金额小数部分
  let ChineseStr = ''; //输出的中文金额字符串
  let parts; //分离金额后用的数组，预定义
  if (money === '') {
    return '';
  }
  // eslint-disable-next-line no-param-reassign
  money = parseFloat(money);
  if (money >= maxNum) {
    return '';
  }
  if (money === 0) {
    ChineseStr = cnNums[0] + cnIntLast + cnInteger;
    return ChineseStr;
  }
  // eslint-disable-next-line no-param-reassign
  money = money.toString(); //转换为字符串
  if (money.indexOf('.') === -1) {
    IntegerNum = money;
    DecimalNum = '';
  } else {
    parts = money.split('.');
    // eslint-disable-next-line prefer-destructuring
    IntegerNum = parts[0];
    DecimalNum = parts[1].substr(0, 4);
  }
  if (parseInt(IntegerNum, 10) > 0) {
    //获取整型部分转换
    let zeroCount = 0;
    let IntLen = IntegerNum.length;
    for (let i = 0; i < IntLen; i++) {
      let n = IntegerNum.substr(i, 1);
      let p = IntLen - i - 1;
      let q = p / 4;
      let m = p % 4;
      if (n === '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          ChineseStr += cnNums[0];
        }
        zeroCount = 0; //归零
        ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m === 0 && zeroCount < 4) {
        ChineseStr += cnIntUnits[q];
      }
    }
    ChineseStr += cnIntLast;
    //整型部分处理完毕
  }
  if (DecimalNum !== '') {
    //小数部分
    let decLen = DecimalNum.length;
    for (let i = 0; i < decLen; i++) {
      let n = DecimalNum.substr(i, 1);
      if (n !== '0') {
        ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (ChineseStr === '') {
    ChineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (DecimalNum === '') {
    ChineseStr += cnInteger;
  }
  return ChineseStr;
}

/**
 * 获取枚举中的文案
 */
export const enumFn = (value, enums, label = 'label') => {
  const status = _.find(enums, (item) => item.value === value);
  if (status && status[label]) {
    return status[label];
  }
  return null;
};

/**
 * 获取枚举中的文案
 */
export const findEnumFn = (value, enums) => {
  const status = _.find(enums, (item) => item.value === value);
  return status || null;
};

/**
 * 时间格式转换
 */
export const fmtDate = (value, fmt) => {
  if (_.isUndefined(value)) {
    return '';
  }
  let dt = moment(value);
  if (!dt.isValid()) {
    return '';
  }
  return dt.format(fmt);
};

export const datetimeFn = (value, fmt = 'YYYY-MM-DD HH:mm:ss') => {
  return fmtDate(value, fmt);
};
export const dateFn = (value, fmt = 'YYYY-MM-DD') => {
  return fmtDate(value, fmt);
};
